function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "np_double-check_3127412_000000",
  d: "M26.017,26.492a1.433,1.433,0,0,0-2.019,0l-8.179,8.2-2.094-2.1,4.115-4.115a1.428,1.428,0,0,0-2.019-2.019L7.614,34.7,4.889,31.97a1.428,1.428,0,1,0-2.019,2.019l3.736,3.736a1.39,1.39,0,0,0,1.01.4,1.418,1.418,0,0,0,1.01-.429L11.7,34.62,14.784,37.7a1.39,1.39,0,0,0,1.01.4,1.463,1.463,0,0,0,1.01-.429l9.214-9.214a1.33,1.33,0,0,0,0-1.969Z",
  transform: "translate(-2.453 -26.05)",
  fill: "currentColor"
});

function SvgDoubleVSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 12.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleVSign);
export default __webpack_public_path__ + "static/media/double-v-sign.d1c75829.svg";
export { ForwardRef as ReactComponent };